/* eslint-disable linebreak-style */
// -------------------------------------
// Dependencies
// -------------------------------------
// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';

// Style includes
import 'snippets/swiper-control/swiper-control';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_series-shop-element.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--series-shop-element';
const CAROUSEL_CLASS = 'carousel--series-shop-element';
const CAROUSEL_SECTION_SELECTOR = '.series-shop-element';
const CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';


// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for scroll bar
        element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-scrollbar-${index}`);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [ Scrollbar, A11y, Keyboard ],
            slidesPerView: 1.1,
            spaceBetween: 5,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 2
                },
                // when window width is >= 1024
                1100: {
                    slidesPerView: 4
                }
            },

            scrollbar: {
                el: `.${CAROUSEL_CLASS}-scrollbar-${index}`,
                draggable: true
            }
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink?.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });
    });


